<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="ch02">
<h2 class="calibre9" id="calibre_pb_1">Chapter II. <br class="calibre13"/> The Affair in the Maze</h2>
<p class="calibre14">Howard Torrance fidgeted a little and then turned to the girl
beside him.</p>
<p class="calibre15">“A bit feeble, just sitting about like this and doing nothing.
Care to go down to the tennis courts and play a single?”</p>
<p class="calibre15">Vera Forrest knew the symptoms well. A good many men
would have been glad enough of the chance to monopolise her
and would have asked nothing better than to sit there in the
shade in her company. But Howard had a surplus of physical
energy which could be worked off only by continual exercise.
“What’ll we do next?” was a phrase which ran through his
talk like a reiterated battle-cry; and he seemed to have exalted
Sloth to the premier position in his private catalogue of the
mortal sins. She glanced at him mischievously and decided
to tease him a little before letting him have his way.</p>
<p class="calibre15">“No, thank you,” she said, sedately.</p>
<p class="calibre15">Howard had a second suggestion ready.</p>
<p class="calibre15">“Want to go over to the links and play a few holes?”</p>
<p class="calibre15">“No, thanks.”</p>
<p class="calibre15">“What about taking the car to Stanningleigh. I need some
cigarettes and I’ll stand you a box of chocolates.”</p>
<p class="calibre15">“No.”</p>
<p class="calibre15">Howard looked at her suspiciously.</p>
<p class="calibre15">“Is this a new game? ‘No, thank you. . . . No, thanks. . . .
No.’ Trying to make it shorter each time, is that it? Well, you’ve
got to the bottom of the bag this shot. This is where the
master-brain says ‘Checkmate!’ Ahem! Like to take a boat out on the
river for a while? You can’t say No in less than two letters.”</p>
<p class="calibre15">Vera made no audible response, but she shook her head
in refusal. Her companion admitted his defeat gracefully.</p>
<p class="calibre15">“Didn’t think you’d manage it. You win. Will you have
a saucepan or a cheap alarm clock? All the other prizes have
been awarded already.”</p>
<p class="calibre15">Then, as though dismissing trifles and becoming serious:</p>
<p class="calibre15">“What’s to be done? We can’t sit around like this the
whole day. Time’s on the wing, and all that.”</p>
<p class="calibre15">Vera looked at the shadows on the grass.</p>
<p class="calibre15">“It’s getting on certainly. We really haven’t time to do much
before tea.”</p>
<p class="calibre15">“It couldn’t miss that, I suppose? It wants its tea?”</p>
<p class="calibre15">“It wants its tea,” Vera admitted, gravely.</p>
<p class="calibre15">Howard looked at his watch.</p>
<p class="calibre15">“Pity we wasted the best part of the afternoon just sitting
round and loafing,” he commented disconsolately.</p>
<p class="calibre15">For a few moments he remained silent, evidently turning
various projects over in his mind.</p>
<p class="calibre15">“Tell you what,” he suggested at last. “Ever been in the
old Maze down there by the boat-house? No? Neither have
I. What about dashing over and trying our luck with it?
Part at the entrance; and the first that gets to the centre wins
the game. They say it’s a grand puzzler.”</p>
<p class="calibre15">“Well, if it will make you happy, I don’t mind. But wait
a moment. Hasn’t the Maze got two centres? Somebody
told me that once.”</p>
<p class="calibre15">Howard brushed the objection aside.</p>
<p class="calibre15">“The first one to reach either centre scores a win. If you
get there, sing out. I’ll trust to your native honesty to keep
you from cheating.”</p>
<p class="calibre15">It was comfortable under the trees, and Vera attempted to
put off the evil moment of departure even by a few seconds.</p>
<p class="calibre15">“How many entrances has the Maze?”</p>
<p class="calibre15">“Oh, don’t know, exactly. Four or five, I think. Nothing
in that. Take the first one we come to, whichever it is. Then
you go to the right and I’ll go to the left, or t’other way about
if you like; and the best man wins. I’ll risk a box of
chocolates or a tin of cocoa on it, if you insist. Come along,
don’t let’s decay here any longer; I see a bit of moss has
grown on my toe since we sat down—and no wonder.”</p>
<p class="calibre15">Vera gave in and rose from her seat with feigned reluctance.</p>
<p class="calibre15">“Bit stiff in the joints with sitting so long?” Howard
inquired, sympathetically. “It’ll wear off at once.”</p>
<p class="calibre15">As they sauntered across the stretches of turf which led down
to the Maze, Vera was struck by the quietness of the grounds.</p>
<p class="calibre15">“Whistlefield’s a lovely place, isn’t it, Howard?”</p>
<p class="calibre15">“Top-hole,” he agreed, cordially. “First-class tennis courts;
good golf-course only a quarter of an hour away; the river’s
quite decent for punting; plenty of room in the house to dance,
and I believe they run a pack of otter-hounds somewhere in the
neighbourhood.”</p>
<p class="calibre15">“I didn’t know you were a house-agent.”</p>
<p class="calibre15">Howard saw the dig, but took no offence.</p>
<p class="calibre15">“Sounds a bit like their patter, doesn’t it? ‘Company’s
water, gas, and electric light. Telephone. Main drainage.’
Well, nothing to be ashamed of, is it? Whistlefield’s all right.”</p>
<p class="calibre15">“Sylvia’s lucky to be here. By the way, where has she gone to
this afternoon, do you know? I haven’t seen her since lunch.”</p>
<p class="calibre15">“Off in the car to see some people and arrange for some
tennis to-morrow. I must say Sylvia looks after one well
when one comes to stay. Always on the go.”</p>
<p class="calibre15">“Where are the rest of the villagers?”</p>
<p class="calibre15">“One uncle’s off with Sylvia. The other two were in the
study when I saw them last. Stenness is somewhere around.
I met young Arthur when you sent me up to the house a few
minutes ago. He was coming out of the gun-room with a
nasty look in his eye and an air-gun in his hand. Gave him
a cheery hail and got a grunt in reply. Seemed peevish about
something or other, quite fretful, even. Wished him Good
Hunting and asked him if he was going to shoot rabbits in
the spinney. All I got was a growl that he was going to
shoot something sitting if he couldn’t shoot it any other way.
Seemed determined to work off bad temper by slaughtering
something, no matter what!”</p>
<p class="calibre15">Vera’s face betrayed sympathy.</p>
<p class="calibre15">“Poor Arthur! It’s hard lines on that boy, Howard. He’s
been changed a good deal by that beastly illness he had.”</p>
<p class="calibre15">Howard’s expression showed that he shared her feelings.</p>
<p class="calibre15">“Pity. Used to be a bright lad. All right, even yet; but
not quite the same, somehow. Moody at times; and apt to
loaf about doing nothing for half the day. No real go in
him. A queer temper, too, some days. When I met him just
now, for instance, he looked ready to bite me in the gizzard.
Not at all the society man.”</p>
<p class="calibre15">Vera dismissed the subject, which threatened to throw a
gloom over them both. They liked Arthur Hawkhurst, in
spite of the occasional flashes of abnormality which he had
shown since the attack of encephalitis lethargica.</p>
<p class="calibre15">“You’re playing quite fair, aren’t you, Howard? You’ve
never been inside the Maze at all?”</p>
<p class="calibre15">“You don’t suppose I’d cheat for the sake of winning a tin
of cocoa, do you? It’s amazing what a low view of mankind
some girls have. Soured from the cradle, what? And born
in suspicion, belike. Shake it off, or it’ll grow on you, Vera.
Go and dig in the garden when you feel an attack coming on.”</p>
<p class="calibre15">“Oh, don’t rub it in! I know your motto well enough:
‘Perspiration is better than cure,’ or something like that, isn’t
it? I only asked out of idle curiosity. No reflections on your
honesty really intended.”</p>
<p class="calibre15">“Your apology of even date duly received and filed. Sounds
like the house-agent vein again, that, doesn’t it? Come on,
I’ll race you this last hundred yards and give you a start to
that rhododendron. Half a tin of cocoa on the event, since
you’re so mercenary.”</p>
<p class="calibre15">Vera rejected his offer; and they walked over the last lawn
to the nearest entrance to the Maze.</p>
<p class="calibre15">The Maze at Whistlefield was a relic of earlier days when
such things were fashionable; but it had been kept in good
repair, and Roger Shandon’s gardeners spent a considerable
amount of labour in clipping its topiary hedges into the
semblance of green walls. Somewhat irregular in outline, it
covered about half an acre of ground; but into that limited
space there was compressed more than half a mile of
pathways; and the shortest route to either of the centres was at
least two hundred and fifty yards in length. But few except
experts could have found their way to either Helen’s Bower
or the Pool of Narcissus by walking a mere two hundred and
fifty yards. The Whistlefield Maze was a labyrinth far
exceeding in complexity its kindred at Hatfield and Hampton Court.
Its twelve-foot hedges were impenetrably thick; and in its
design it followed the “island-pattern” to such an extent that
incautious explorers might wander by the hour through its tiny
archipelago without gaining a foot towards the innermost
recesses or even realising that they were simply coasting round
and round the outline of some detached hedge.</p>
<p class="calibre15">So many people had got temporarily lost in the labyrinth
and, being so far away from the house, had been unable to
get help even by shouting, that at last precautions had been
taken to avoid mishaps of the kind in future.</p>
<p class="calibre15">As Vera and her companion reached the tall iron gate in
the outer hedge which marked one of the entrances, they
found themselves confronted with a small notice-board to
which an old-fashioned horn was suspended.</p>
<blockquote class="notice"><div class="calibre17">
  Visitors entering the maze are advised to take
  this horn with them so that they can summon
  assistance if necessary. On leaving the maze,
  kindly hang the horn in its place again.
</div>
</blockquote>
<p class="calibre15">Howard went up to the board and read the notice with
obvious contempt.</p>
<p class="calibre15">“Nice lot of incompetents they seem to have about the
house!” he commented in a scathing tone. “I wonder they
don’t provide a bath-chair and a man to push you to the centre,
and be done with it. As if any person of ordinary intelligence
couldn’t find his way through a thing about the size of a
washing-green.”</p>
<p class="calibre15">“Ever been in a maze before?” Vera inquired.</p>
<p class="calibre15">“No, not that I can remember.”</p>
<p class="calibre15">“Ah, then kindly unhook the horn and give it to me. I’m
not proud.”</p>
<p class="calibre15">Howard took the horn from its place and handed it over.</p>
<p class="calibre15">“What’s the good of one horn, since we’re not going in
together?”</p>
<p class="calibre15">Vera looked him over coldly.</p>
<p class="calibre15">“When I get lost, I shall blow the horn and get someone
to show me the way out. When you get lost, you’ll be able
to practise breathing exercise in yelling for help. You see,
you’ve got a much louder and harsher voice than I have.
You’ll be all right, I’m sure. But if you think you can’t come
up to the lung-power needed, you might go round to the next
entrance and see if there isn’t a horn there. I should think
there’s sure to be one at each entrance.”</p>
<p class="calibre15">Howard was put on his mettle.</p>
<p class="calibre15">“Oh, I shan’t get lost. Don’t fret too much about me.
Now then, who’s for the centre?”</p>
<p class="calibre15">“Come along, then. I’ll take the left-hand path here, and
you can go to the right. Whoever gets first to the centre can
shout ‘I win!’ and then start for the exit door. If it’s a tie at
the centre, then the first one out is the winner. Keep a tight
hold on your honesty and don’t shout unless you get to the
centre! These are all the directions necessary, I think. Now, go!”</p>
<p class="calibre15">Vera hurried along a straight corridor for some twenty yards
and then turned sharply to the right as the path altered its
direction. On again, until a promontory of hedge forced her
to diverge into a recess in the greenery, from which she emerged
again into the main track. Another corner to the right was
turned and now she seemed to have come into a cul-de-sac.</p>
<p class="calibre15">“Rather a sell if I’ve chosen a blind alley at the very start,”
she thought to herself. “Howard would jubilate over that
when he found out about it.”</p>
<p class="calibre15">However, on reaching the wall of hedge which seemed to
bar her way, she came upon a concealed turning to the right.</p>
<p class="calibre15">“After walking all that distance, I’m still on the very outer
rim of this Maze! However, this turn’s going to take me in
towards the centre.”</p>
<p class="calibre15">Up to that point her progress had been simplicity itself; but
now alternative paths began to open up every few yards. The
tall hedges cut off everything but the sky; and soon she found
that she had completely lost her bearings and was wandering
at random. For a time she hurried forward, choosing always
those turnings which seemed likely to bring her nearer to
where she supposed the centre to lie; but at last the continual
windings confused her so much that she could not even tell in
which direction to walk in order to reach the inner reaches of
the labyrinth. Long zig-zag corridors ended, time after time, in
blank walls; and in traversing them forwards and back again
she grew more and more doubtful of her bearings. When she
thought of taking the sun as a reference-point, it was too late;
for by that time she had lost all notion of her whereabouts.</p>
<p class="calibre15">“I’m sure I’ve seen that patch of withered leaves in the
hedge more than once before,” she said to herself, halting to
examine it more carefully. “Yes, I’m certain I passed it a few
minutes ago. I must be coming back in my tracks and just
going over the same ground again and again.”</p>
<p class="calibre15">With the dying out of her own footfalls, the silence of the
Maze impressed itself on her; and she strained her ears to
catch the sound of Howard as he moved somewhere beyond
these impenetrable green living walls.</p>
<p class="calibre15">“If I really get stuck in here,” she reflected, “I can always blow
the horn and bring someone who knows the place to lead me out.”</p>
<p class="calibre15">She listened again, more intently. Then, suddenly there was
no need to strain her ears.</p>
<p class="calibre15">First came a dull thud, which unconsciously she recognised
as familiar, though she could not identify it at the moment.
Then, almost at the same instant, a man’s voice gave an
inarticulate cry in which surprise, pain, and anger seemed to be
mingled. A moment of silence, then a peculiar metallic grating
reached her ears, followed by a second thud and a fresh cry of
pain. Again came the familiar metallic rasping, yet another
of these familiar dull concussions, and then, lower this time,
a last cry. Then there was silence once more.</p>
<p class="calibre15">Vera stood paralysed by what she had heard. In a flash
of enlightenment she guessed that behind these inexplicable
events some tragedy was in progress; something dreadful was
happening quite close at hand, though screened from her by
the high green walls which shut her in. She had never heard
that note in a man’s voice before. Utterly shocked by the
unexpected revelation of violence, she stood for a moment with
her knees trembling under her, while her pulse beat in her
throat so heavily as to prevent her uttering a sound. Then,
with an effort, she found her voice.</p>
<p class="calibre15">“Howard! Are you there? What’s happened? Oh, what’s
happened?”</p>
<p class="calibre15">“I’m here.”</p>
<p class="calibre15">She could not make out from which direction his shout came.
The towering hedges seemed to deflect sound so that it was
impossible to determine even approximately the position of a speaker.</p>
<p class="calibre15">“What were those cries, Howard? What’s happened?”</p>
<p class="calibre15">“I don’t know,” he answered. “Somebody hurt. But I
can’t get to the place. Stay where you are, Vera. I’ll see if
I can find my way to you.”</p>
<p class="calibre15">She listened intently in the silence that followed. Feet
moved in the Maze; evidently Howard was doing his best to
make in her direction. But beyond this she could detect no
other noise, though she strained her ears to the utmost. She
had expected to hear groans from the wounded man, but
nothing broke the stillness until Howard called to her again.
His voice seemed farther off than before.</p>
<p class="calibre15">“Shout, will you, Vera? I’ve lost your direction.”</p>
<p class="calibre15">She called again; and he replied. But as she listened, his
footsteps seemed to recede and die away in the distance.
Evidently he had found that the direct path was blocked and had
had to retreat up some alley to try a fresh start.</p>
<p class="calibre15">Then, with surprise at her previous forgetfulness, she
bethought herself of the horn in her hand. That would bring
assistance. She ought to have remembered it before. The
shock had put it out of her mind. She was in the act of
lifting it to her lips when again her nerves were shaken by a new
cry from the inner recesses of the Maze.</p>
<p class="calibre15">“Murder!”</p>
<p class="calibre15">She recognised Howard’s voice, tinged with horror. It was
a loud-voiced ejaculation rather than a cry for assistance, she
felt with relief. Howard hadn’t run into a trap. Before she
could pull herself together, he shouted again, this time with
the full strength of his lungs:</p>
<p class="calibre15">“Murder! See that no one gets away from the Maze!”</p>
<p class="calibre15">Vera’s nerves were almost attuned to the shock of the
discovery. A picture of some swift and terrible act of violence
crossed her mind. It must have been soon over, for she
remembered that after the three cries she had heard no sound
of any sort. Not twenty yards from her, it might be, a human
being had been battered out of existence; and but for these
cries she would have known nothing whatever.</p>
<p class="calibre15">She raised her voice again.</p>
<p class="calibre15">“Howard! I’m frightened. What’s happened?”</p>
<p class="calibre15">“One of the Shandons has been killed. I blundered into
the centre, trying to get to you. There’s blood on his coat.”</p>
<p class="calibre15">He broke off for a moment, evidently gathering his breath,
then again he shouted:</p>
<p class="calibre15">“Murder! Help! Here in the Maze! Murder!”</p>
<p class="calibre15">Vera held her breath, listening eagerly for some answering
cry from the outer world which now seemed so peaceful and
unattainable. Then in the silence, she heard the sound of a
man running hard in the alleys of the Maze.</p>
<p class="calibre15">“Is that you, Howard?” she called. “I hear someone
running not far from where I am.”</p>
<p class="calibre15">No sooner had she spoken than the noise of running
footfalls ceased abruptly.</p>
<p class="calibre15">“Is that you, Howard?” she called again, nervously.</p>
<p class="calibre15">There came a sound of rustling and tearing, then Howard’s
voice sounded across the labyrinth.</p>
<p class="calibre15">“I’m here. I’m trying to get to you. I tried climbing the
hedge, but it’s no good. What did you say? I didn’t catch it.”</p>
<p class="calibre15">“There’s somebody moving about in the Maze, Howard.
I heard his footsteps.”</p>
<p class="calibre15">Howard Torrance’s voice replied with that baffling
indeterminateness in direction which the Maze seemed to impart.</p>
<p class="calibre15">“Can you hear me, Vera?”</p>
<p class="calibre15">“Yes.”</p>
<p class="calibre15">“Well, don’t utter another sound. Don’t use the horn. Keep
absolutely quiet and try to make your way out of the Maze.
If anyone comes round the corner, yell your head off; but unless
you see something, keep silent and step softly. There’s
someone in the Maze, and I don’t want him to know where you are.”</p>
<p class="calibre15">Vera leaned against the high hedge for a minute or two,
trying to overcome the panic into which Howard’s last words
had plunged her. He had been careful not to put the thing
to her nakedly; but she saw what lay behind his directions.
The murderer was still in the Maze, and on his way out he
might come upon her. If he did, she would be too dangerous
a witness to leave alive. She need expect no mercy. And
what hope of escape would she have? There, shut in among
these towering walls, isolated from all help in the intricacies of
the Maze, it would be an easy business to silence her finally.</p>
<p class="calibre15">She listened intently once more; but no sound came to her
ears. The murderer seemed to have made his way into some
remoter part of the Maze. Suddenly a clatter at her feet
startled her into an agony of terror. It was the horn which
she had allowed to slip from her hand in the intensity of her
concentration upon the sounds about her. She stooped to
pick it up again; then, thinking that it would merely hamper
her, she let it lie where it had fallen.</p>
<p class="calibre15">But at once came the realisation that the sound of its clash
upon the path must have betrayed her position, if the
murderer were lurking at hand. She tried to listen again; but her
heart was hammering and the pulsing of the blood in her ears
drowned all external sounds. A lump seemed to gather in her
throat and she felt as though she would choke. With a
physical effort she fought down her difficulties.</p>
<p class="calibre15">“Hysteria!” she told herself. “If I give way to it, I’ll be
putting myself straight into the brute’s hands.”</p>
<p class="calibre15">At last the rustle in her ears subsided and she was able to
listen again. For a few instants she heard nothing. Then,
quite close at hand, a dry twig cracked as though someone had
set his foot on it. The murderer had not left the Maze.</p>
<p class="calibre15">She felt almost unable to stir; but at last she forced herself
into motion. Anything was better than staying in the place where
the assassin might have heard her drop the horn. Softly she stole
down the corridor. Once she had begun to move, all her
impulse was to break into a run; but she fought hard against it.</p>
<p class="calibre15">“If I begin to run, I’m done for,” she thought. “I’d go on
running. I wouldn’t be able to run to a corner; and it’s at
the corners I must be careful, or I may run full tilt into him.”</p>
<p class="calibre15">And then her mind, despite herself, conjured up vivid
pictures of that meeting. She could see a vague figure rising to
block her passage. With an almost physical shrinking she
thought of it with a knife in its hand, the blade dripping with
the blood of the earlier victim. It came over her how safe
and peaceful the normal world was—and now, in pursuit of
an aimless piece of amusement, she had come into the
slaughterhouse. The Minotaur was afoot in the labyrinth.</p>
<p class="calibre15">At the end of the alley she forced herself to halt and peeped
cautiously round the corner. No one was in sight, so she
ventured into a fresh avenue. Then came a fork in the path,
and she took the passage which seemed to offer the longest
clear view ahead. Then another corner, and more precautions.</p>
<p class="calibre15">She was moving at random now, all her attention
concentrated on avoiding the unseen assassin. Once she heard steps,
someone was walking on the opposite side of the hedge against
which she was crouching. She held her breath, pictured that
terrific figure which she had conjured up. He was stepping
lightly like herself; and she almost feared that he would hear
the beating of her heart, so near did he come. Then, when she
thought she could bear it no longer, the footfalls receded
softly into the distance.</p>
<p class="calibre15">“If that happens again, I’ll shriek,” she said to herself. “I
simply couldn’t go through it twice.”</p>
<p class="calibre15">Two more corners rounded in safety, then in a straight alley
a metallic object glittered at the foot of the hedge and with a
sinking heart she recognised it as the horn she had dropped.</p>
<p class="calibre15">“I’m back again at the same place. I’ll never get out of
this trap!”</p>
<p class="calibre15">Again she started, stepping as softly as possible; but to her
strained ears the sound of her footsteps seemed to echo and
re-echo along the green-walled corridors.</p>
<p class="calibre15">“What a fool I am! I ought to have taken off my shoes
long ago. Then I could go as quick as I please, without making
any noise.”</p>
<p class="calibre15">She slipped off her shoes, and some of her confidence came
back when she found how silently she could move.</p>
<p class="calibre15">“Now I must keep things in my head and get off the track
I followed last time.”</p>
<p class="calibre15">At one remembered turning, she took a fresh track and stole
along it with every precaution. Again she heard the sound of
steps; but they were farther off this time, and after halting for
a few seconds she felt safe to go on her way once more.</p>
<p class="calibre15">“If I don’t get out soon, I’ll faint.”</p>
<p class="calibre15">But she refused to give in. The thought of lying helpless
in one of these tenantless corridors at the mercy of the hidden
murderer, kept her on her feet.</p>
<p class="calibre15">“He’d think I was shamming, and he’d make sure of me.”</p>
<p class="calibre15">The thought of that fate was just sufficient to nerve her to
a desperate attempt to extricate herself from the labyrinth; but
now her self-control gave way. She began to hurry along the
interminable corridors, and before many seconds had passed she
had broken into a run. Soon she was flying headlong down
the alleys, slipping as she turned corners in full flight, dashing
blindly into hedges which blocked her path in culs-de-sac, and
striving only to outstrip the phantom murderer whom she felt
at her heels. All thought of caution or direction had gone to
the winds as she fled at haphazard down the tortuous paths.</p>
<p class="calibre15">Just as she felt that she could force herself no farther, a
wider gap than usual appeared in one of the green walls, and
she flung herself into it in the hope that it might be one of the
exits. But instead of the broad lawns of Whistlefield, she found
before her a tiny open space shut in on all sides by greenery.</p>
<p class="calibre15">A few garden chairs were scattered about it, under the shade
of the hedges. One of them had been overturned, and beside
it lay, face upwards, the body of a man in grey flannel clothes.
Vera had never seen a dead man before; but it needed no
second glance to tell her that she had stumbled upon the
victim of the tragedy.</p>
<p class="calibre15">“It’s Roger Shandon!”</p>
<p class="calibre15">Almost subconsciously she noted that the body showed no
visible signs of violence. Roger seemed to have collapsed as
he rose from his chair. She could see no pool of blood which
might have pointed to the manner of his death.</p>
<p class="calibre15">Vera’s nerves could withstand the strain no longer. The
glimpse of the body proved to be the final touch which was
more than she could bear. Almost incuriously she noticed
the blue sky darken, turn violet, and then go black. She
retreated a couple of paces, only to go down in a faint.</p>
<p class="calibre15">When she came to her senses again, it was to hear the
sound of her own name in her ears; but when she looked
round she could see no one standing beside her.</p>
<p class="calibre15">“Vera! Are you there? Why don’t you answer?”</p>
<p class="calibre15">Slowly she came back to normal consciousness and the
realisation that it was Howard Torrance’s voice continually calling.</p>
<p class="calibre15">“Vera! Answer if you can. What made you shriek like that?”</p>
<p class="calibre15">So she must have uttered some involuntary cry before she
fainted. She turned this over in her mind mechanically, hardly
yet knowing where she was. Then all at once things came
back to her and she rose to her knees. Roger Shandon’s body
was close to her, and she turned away her head so as not to
see the dead man.</p>
<p class="calibre15">“Vera!”</p>
<p class="calibre15">She pulled herself together and answered with a faint call.</p>
<p class="calibre15">“Thank God you’re all right,” she heard Howard answer.</p>
<p class="calibre15">“Where are you?”</p>
<p class="calibre15">“I’ve come to the centre where the body is. Oh, Howard,
what am I to do?”</p>
<p class="calibre15">“The murderer’s gone, I think,” came the reply. “Can you
walk at all? Get away from that place at once. No wonder
you shrieked when you came upon it. If you’ll call as often
as you can manage it, I’ll try to find my way to you.”</p>
<p class="calibre15">With an effort she forced herself to her feet once more.
Her strength seemed to be almost gone; but by sheer
will-power she succeeded in making her way out of the tiny
enclosure into the green corridor. Anything to get away from
the sight of the body! It was too grim a reminder of the
perils of the Maze.</p>
<p class="calibre15">For a time she leaned against the hedge just outside the
centre, trying to gather up enough energy to launch once more
into the labyrinth. One horror had at least been banished.
Howard said the murderer had escaped from the Maze; she
need have no fear of meeting that demon in her wanderings.
It seemed hours since she and Howard had come so
light-heartedly into that daedalian web. She had no idea how
long she had been unconscious; and when she looked back,
she seemed to have spent an eternity in the paths of the Maze
before she had blundered into the centre.</p>
<p class="calibre15">At last she pulled herself together and called again to
Howard.</p>
<p class="calibre15">“Howard! I’m going to try for the way out now.”</p>
<p class="calibre15">“All right! Give me a call occasionally, so that I’ll know
you’re all right. By the way, why don’t you blow the horn?”</p>
<p class="calibre15">“I’ve lost it. I dropped it when I thought the murderer
was chasing me.”</p>
<p class="calibre15">“I wondered why you didn’t use it, after I’d told you he’d
cleared out. Shouting’s no good. I’ve been yelling at the pitch
of my voice for long enough, but there’s no one within earshot,
evidently.”</p>
<p class="calibre15">Vera set off again. The rest had done her good. Now that
the immediate terror of the murderer in the Maze was removed,
she felt a different person. The horror through which she had
passed began somehow to take on a tinge of unreality. Had she
actually seen Roger Shandon’s body lying on the grass, or had
it been a mere hallucination sweeping over her when she was
on the verge of fainting? She had the feeling that the whole
thing might be some walking nightmare which had passed.</p>
<p class="calibre15">And now, by that curious hazard which sometimes happens
in mazes, she hit upon the shortest route to the exit. When she
was least expecting it, a sudden turn in the corridor revealed
one of the iron gates in the outermost hedge.</p>
<p class="calibre15">“Howard! I’ve come to the gate. What a relief!”</p>
<p class="calibre15">“Wait before you go,” Howard’s voice came to her over
the intervening partitions. “Listen to me. Once you get
outside, run to the house. If you meet anyone on the way, send
him down to get me out of this tangle; I seem to have no luck.
When you get to the house, find Stenness or one of the other
men. Send the lot, if they’re there. Tell them about the
murder and tell them to get the police on the ’phone at once.
And get yourself some brandy or something. You’ll need it,
poor thing!”</p>
<p class="calibre15">Vera made a careful note of his orders.</p>
<p class="calibre15">“I’ll see to that. I’m going now, Howard. Good-bye.”</p>
<p class="calibre15">She ran out of the iron gate and saw with immense relief
the broad prospect of the lawns before her. Out at last!
Then she hurried off in the direction of the house.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?435c5dd6